import React from 'react';
import './Lightbox.css';

const Lightbox = ({ image, onClose }) => {
  if (!image) return null;

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={e => e.stopPropagation()}>
        <img src={image} alt="zoom" />
        <button className="lightbox-close" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default Lightbox;
